import React, { useEffect } from "react";
import Navbar from "../components/navbar";
import Footer from "../components/footer";

import Switcher from "../components/switcher"; // Ensure the correct path to Switcher
import Productos from "../components/Productos"; // Ensure the correct path to Productos
import InsuranceProcess from "../components/InsuranceProcess";
import cargo from "../assets/images/sidom/fotos/insurance/bannerCard-Insurance1.png";
import Containers from "../assets/images/sidom/fotos/insurance/bannerCard-Insurance2.png";
import Surety from "../assets/images/sidom/fotos/insurance/bannerCard-Insurance3.png";
import Risk from "../assets/images/sidom/fotos/insurance/bannerCard-Insurance4.png";
import Stock from "../assets/images/sidom/fotos/insurance/bannerCard-Insurance5.png";
import Soporte from "../assets/images/sidom/fotos/insurance/bannerCard-Insurance6.png";
import imgL from "../assets/images/sidom/fotos/insurance/svg/caucion.svg";
import imgD from "../assets/images/sidom/fotos/insurance/svg/caucionD.svg";
import imgLl from "../assets/images/sidom/fotos/insurance/svg/carga.svg";
import imgDd from "../assets/images/sidom/fotos/insurance/svg/cargaD.svg";
import VideoBackground from "../components/VideoBackground";
import GetInTuch from "../components/getInTuch";
import CardBeneficios from "../components/CardBeneficios";
import useStore from "../store/useStore";

const steps1 = [
  "Despachante recibe el requerimiento por parte de la aduana y una cotización por el seguro de Caución solicitado.",
  "El Despachante genera la solicitud desde el sistema Misim para que se emita la Caución. El despachante puede contratar en nombre del cliente o involucrar al Broker y al Importador.",
  "La Aseguradora emite la póliza.",
  "El Despachante afecta la póliza de caución.",
  "Mercadería liberada por Aduana.",
];
const steps2 = [
  "Se necesita mover mercadería de un Punto A a un Punto B.",
  "Surge la necesidad y el requerimiento de contratar un seguro que las proteja de los riesgos inherentes al transporte.",
  "Desde MiSIM el usuario puede cotizar el seguro para la mercadería, de acuerdo a las condiciones de la póliza flotante.",
  "Contrata el seguro, con una emisión en tiempo real de la póliza avalada por la aseguradora, teniendo cobertura desde ese momento.",
];
const productos = [
  {
    title: "Cargo",
    description:
      "Optimizamos procesos, logrando mitigar riesgos en las operaciones logísticas de transporte marítimo, aéreo y terrestre. Brindamos cotizaciones en el acto, evitando las pérdidas de tiempo.",
    img: cargo,
  },
  {
    title: "Containers",
    description:
      "Nuestra tecnología ofrece una solución integral y sin complicaciones para contratar seguros de contenedores, garantizando su estado óptimo y devolución puntual.",
    img: Containers,
  },
  {
    title: "Surety",
    description:
      "Diseñamos un producto que permite a nuestros clientes ofrecer garantías ininterrumpidas las 24 horas, los 7 días de la semana, con las condiciones más favorables.",
    img: Surety,
  },
  {
    title: "Risk-Management",
    description:
      "Agilizamos los procesos en el gerenciamiento de riesgo, trabajando con partners líderes en la región y garantizando la seguridad para mover tu mercadería o la de tus clientes.",
    img: Risk,
  },
  {
    title: "Stock",
    description:
      "Contamos con un equipo capacitado para dar soporte e identificar oportunidades de mejora y desarrollo de nuevas coberturas. La obsesión por la excelencia marca el norte.",
    img: Stock,
  },
  {
    title: "Soporte y Conocimiento",
    description:
      "Contamos con un equipo capacitado para dar soporte e identificar oportunidades de mejora y desarrollo de nuevas coberturas.",
    img: Soporte,
  },
];

const productos2 = [
  {
    title: "Amplia oferta de Coberturas",
    description:
      "Contamos con el ecosistema de soluciones necesarias para cubrir todas las necesidades de las operaciones de comercio internacional.",
  },
  {
    title: "Automatización del Proceso",
    description:
      "Cotización y contratación de seguros en 5 simples pasos, permitiendo comparar múltiples ofertas de seguros y con información a tiempo real.",
  },
  {
    title: "Costos mejorados",
    description:
      "Nuestro objetivo es lograr un mercado más transparente para todos los actores, es por eso que nuestros servicios tienen un pricing simple y sin costos ocultos.",
  },
  {
    title: "Personalización",
    description:
      "Customizamos nuestras soluciones y los productos tradicionales de la industria para adaptarlos a las necesidades de los clientes. ",
  },
];

export default function Insurance() {
  const { insurances, getHeroInsurances } = useStore();
  const urlApi = "https://api.institucional.global.sidom.io";

  useEffect(() => {
    getHeroInsurances();
  }, [getHeroInsurances]);
  console.log("Insurance data:", insurances);
  return (
    <div className=" bg-sidom-light dark:bg-sidom-blue text-sidom-dark dark:text-sidom-light">
      <Navbar />
      {/* {hero} */}{" "}
      <div>
        {insurances?.length === 0 || !insurances ? (
          <VideoBackground
            video="/placeholder.mp4"
            titulo1="Cargando..."
            titulo2="Espere un momento"
            textbutton="SOLICITAR DEMO"
            logo="/placeholder-logo.png"
          />
        ) : (
          insurances.map((item, index) => (
            <VideoBackground
              key={index}
              video={`${urlApi}${item.video[0]?.url}`}
              titulo1={item.titulo}
              titulo2={item.text}
              textbutton="SOLICITAR DEMO"
              logo={`${urlApi}${
                item.img[0]?.formats?.thumbnail?.url ||
                item.img?.url ||
                "/placeholder-logo.png"
              }`}
            />
          ))
        )}
      </div>
      <div className=" mt-[100px] mb-[100px]  flex  h-full">
        <div className="  container  leading-[1.3]  relative flex flex-col items-center justify-center">
          <h5 className="leading-[1.3]    mb-[60px] w-full text-sidom-orange text-4xl md:text-5xl font-extrabold text-left   ">
            Transparencia y simplicidad en tu portal de autogestión 24×7
          </h5>

          <div className=" flex flex-col mb-[100px]  text-xl text-sidom-dark dark:text-sidom-light  ">
            <h5 className="leading-[1.3]    mb-[60px] w-full text-sidom-orange text-4xl md:text-5xl font-extrabold text-left ">
              ¿Qué solucionamos?
            </h5>
            <h5 className=" text-balance   ">
              <strong>SIDOM INSURANCE </strong>es la primera solución InsurTech
              de Seguros embebidos para la
              <strong>
                gestión integral de las pólizas de transporte y garantías
                aduaneras{" "}
              </strong>{" "}
              relacionadas con la operatoria de comercio exterior.
            </h5>
            <h5 className="  text-balance mt-[20px]">
              Permite cotizar y contratar todos los seguros de la operatoria de
              Impo/Expo de manera transparente y en tiempo real, logrando
              agilizar y simplificar los procesos logísticos
            </h5>
          </div>
        </div>
      </div>
      <div className=" mt-[100px] mb-[100px] ">
        <div className="container ">
          <Productos productos={productos} />
        </div>
      </div>
      <div className="mt-[100px] mb-[100px]  flex  flex-col h-full">
        <div className=" mb-[60px] mt-[100px]">
          <InsuranceProcess
            title="Cotización y contratación de póliza de Caución Aduanera con"
            subtitle="SIDOM Insurance"
            imageL={imgL}
            imageD={imgD}
            steps={steps1}
          />
        </div>
        <div className=" mt-[100px] mb-[100px]">
          <InsuranceProcess
            title="Cotización y contratación de póliza de Certificado de Carga con SIDOM Insurance"
            subtitle="SIDOM Insurance"
            imageL={imgLl}
            imageD={imgDd}
            steps={steps2}
          />
        </div>
      </div>
      <div className="mt-[100px] mb-[100px] container flex flex-col h-full">
        <h2 className="text-sidom-orange text-4xl md:text-5xl font-extrabold text-left mb-[60px]">
          Beneficios
        </h2>
        {productos2.map((producto, index) => (
          <CardBeneficios
            key={index}
            titulo={producto.title}
            descripcion={producto.description}
          />
        ))}
      </div>
      {/* <div className=" mt-[100px] mb-[100px]">
        <div className="container">
          <InfoCard
            title="¿Tienes alguna pregunta?"
            description="Nos pondremos en contacto para que puedas saltar al próximo nivel."
            buttonText="Contáctanos"
            buttonLink="/contactus"
            backgroundColor="bg-orange-500"
            iconSrc="https://sidomsuite.com/wp-content/themes/sidom-pay/assets/message.png"
          />
          <InfoCard
            title="Global trade"
            description="La única plataforma 100% Web/SaaS para la gestión punta a punta de la operatoria de importadores y exportadores."
            buttonText="Quiero saber más"
            buttonLink="/"
            backgroundColor="bg-sidom-blue"
            iconSrc="https://sidomsuite.com/wp-content/uploads/2024/09/01.png"
          />
        </div>
      </div> */}
      <GetInTuch />
      <Footer />
      <Switcher />
    </div>
  );
}
